function CardWithIconSkeleton() {
  return (
    <div className="my-2 flex items-center gap-2 px-4 py-3">
      <div className="mb-2 h-9 w-9 animate-pulse rounded-full bg-gray-400" />
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div className="mb-2 h-4 w-1/2 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-4 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mb-2 h-4 w-full animate-pulse rounded-md bg-gray-400" />
      </div>
    </div>
  );
}

export default CardWithIconSkeleton;
